"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("core-js/modules/es6.typed.uint8-array");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.function.name");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.set");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.array.find");
require("core-js/modules/es6.number.constructor");
var _xlsx = _interopRequireDefault(require("xlsx"));
var _popupConfig = require("@/api/popup/popupConfig.js");
var _memberManagement = require("@/api/member/memberManagement.js");
var _popupTypes = require("@/utils/popupTypes.js");
var _gradeInfo = require("@/api/basic/gradeInfo");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'MenuPagePopupForm',
  props: {
    // 编辑ID（从路由或父组件传入）
    editId: {
      type: [Number, String],
      default: null
    },
    // 是否为编辑模式
    isEdit: {
      type: Boolean,
      default: false
    },
    // 弹窗类型（菜单页或首页）
    popupType: {
      type: Number,
      default: 1 // 默认为菜单页弹窗
    }
  },
  data: function data() {
    return {
      formData: {
        title: '',
        recommendType: 1,
        sendScene: [],
        isVip: 1,
        vipGrade: [],
        isAddQy: 1,
        isSaleOrder: 1,
        isNewPeopleCoupon: 1,
        userType: 1,
        showImage: null,
        dateRange: [],
        // 默认日期范围
        recommendContent: '',
        recommendContentId: null,
        recommendContentParam: null,
        recommendPriority: 0,
        showPlatform: [1],
        isEnable: true,
        isShow: true,
        remark: '',
        selectedStores: [],
        // 选中的门店列表
        storeJoinType: 1,
        // 1-指定门店参与 2-指定门店不参与
        vipGradeRadio: null,
        // 会员级别单选
        // 分组类型相关字段
        cdpGrpType: 0,
        cdpGrpId: null
      },
      // 图片资源前缀
      imagePrefix: '',
      // 等级相关数据
      vipGrades: [],
      fileList: [],
      // 照片墙文件列表
      previewVisible: false,
      // 预览对话框显示状态
      previewImageUrl: '',
      // 预览图片URL
      storeSearchText: '',
      // 门店搜索文本
      // 树状门店数据
      storeTreeData: [],
      // CDP分组相关数据
      cdpGroupOptions: [],
      allPage: [],
      cdpGroupLoading: false,
      // 树形控件属性
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      // 默认展开的节点
      expandedKeys: [],
      // 默认选中的节点
      checkedKeys: [],
      rules: {
        title: [{
          required: true,
          message: '请输入标题',
          trigger: 'blur'
        }],
        recommendType: [{
          required: true,
          message: '请选择推荐类型',
          trigger: 'change'
        }]
      },
      channelOptions: [],
      contentTypeOptions: [],
      pageOptions: [],
      // 调查问卷模拟数据选项
      surveyOptions: [],
      // 页面列表数据
      pageList: []
    };
  },
  watch: {
    // 监听编辑ID变化并拉取详情
    editId: {
      handler: function handler(newId) {
        if (newId) {
          this.fetchDetailById(newId);
        }
      },
      immediate: true
    },
    storeSearchText: function storeSearchText(val) {
      this.$refs.storeTree.filter(val);
    }
  },
  computed: {
    // 是否选中了登录页面
    isSelectedLoginPage: function isSelectedLoginPage() {
      var _this = this;
      var page = this.pageList.find(function (p) {
        return p.id === _this.formData.recommendContentId;
      });
      return !!page && page.label.indexOf('登录') !== -1;
    }
  },
  mounted: function mounted() {
    // 组件挂载后获取等级列表和图片前缀
    this.getShopList();
    this.getVipGradeList();
    this.getImagePrefix();
    // 获取页面列表
    this.getPageList();
  },
  methods: {
    // 外部小程序类型(社区/其他)切换时清空后续输入框
    changeRecommendContentSub: function changeRecommendContentSub() {
      this.formData.recommendContent = '';
      this.formData.recommendContentId = '';
      this.formData.recommendContentParam = '';
    },
    changeRecommendInfo: function changeRecommendInfo() {
      this.formData.recommendContent = '';
      this.formData.recommendContentId = '';
      this.formData.recommendContentParam = '';
      if (this.formData.recommendType == 3) {
        this.pageList = this.allPage.filter(function (item) {
          return item.appid === 'GAGAX' || item.appid === 'DELI';
        });
      } else if (this.formData.recommendType == 6) {
        this.pageList = this.allPage.filter(function (item) {
          return item.appid === 'GAGAS';
        });
      }
    },
    // 获取门店列表
    getShopList: function () {
      var _getShopList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 1;
              return (0, _popupConfig.getShops)();
            case 1:
              response = _context.sent;
              if (response.code === 200 && response.data) {
                // 转换数据结构以匹配前端期望的格式
                this.storeTreeData = this.transformShopData(response.data);
                // 设置默认展开的节点为所有顶级节点
                this.expandedKeys = this.storeTreeData.map(function (item) {
                  return item.nodeKey;
                });
              } else {
                this.$message.error('获取门店列表失败');
              }
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              console.error('获取门店列表错误：', _t);
              this.$message.error('获取门店列表失败');
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 2]]);
      }));
      function getShopList() {
        return _getShopList.apply(this, arguments);
      }
      return getShopList;
    }(),
    // 转换门店数据结构
    transformShopData: function transformShopData(data) {
      // 后端数据里区域id可能与门店storeId撞号、同一门店可能出现在多个区域下，
      // 直接用 id 作为 node-key 会因 key 重复导致 setCheckedKeys 勾选不上部分门店，
      // 因此用 nodeKey 保证唯一（区域 'r'+id、门店 's'+storeId），并对重复门店/区域去重
      var seenRegionIds = new Set();
      var seenStoreIds = new Set();
      var result = [];
      data.forEach(function (region) {
        if (seenRegionIds.has(region.id)) return;
        seenRegionIds.add(region.id);
        // 复制区域信息
        var transformedRegion = {
          id: region.id,
          nodeKey: 'r' + region.id,
          isRegion: true,
          label: region.label,
          children: []
        };

        // 转换子节点（门店），同一门店只保留第一次出现
        if (region.children && region.children.length > 0) {
          region.children.forEach(function (shop) {
            if (seenStoreIds.has(shop.storeId)) return;
            seenStoreIds.add(shop.storeId);
            transformedRegion.children.push({
              id: shop.storeId,
              // 使用storeId作为id
              nodeKey: 's' + shop.storeId,
              label: shop.shopName,
              // 使用shopName作为label
              regId: shop.regId,
              regName: shop.regName
            });
          });
        }
        result.push(transformedRegion);
      });
      return result;
    },
    // 获取会员等级列表
    getVipGradeList: function () {
      var _getVipGradeList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var response, _t2;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              this.gradeLoading = true;
              _context2.next = 1;
              return (0, _gradeInfo.xyRuleVipGradeSelPage)({
                page: 1,
                limit: 100 // 获取所有等级，如果等级很多可以分页
              });
            case 1:
              response = _context2.sent;
              if (response.code === 200 && response.records) {
                this.vipGrades = response.records.map(function (grade) {
                  return {
                    id: grade.id,
                    name: grade.name,
                    levelId: grade.levelId
                  };
                });
              } else {
                this.$message.error('获取等级列表失败');
              }
              _context2.next = 3;
              break;
            case 2:
              _context2.prev = 2;
              _t2 = _context2["catch"](0);
              console.error('获取等级列表错误：', _t2);
              this.$message.error('获取等级列表失败');
            case 3:
              _context2.prev = 3;
              this.gradeLoading = false;
              return _context2.finish(3);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 2, 3, 4]]);
      }));
      function getVipGradeList() {
        return _getVipGradeList.apply(this, arguments);
      }
      return getVipGradeList;
    }(),
    // 获取图片资源前缀
    getImagePrefix: function () {
      var _getImagePrefix2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var response, _t3;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 1;
              return (0, _memberManagement.getImagePrefix)();
            case 1:
              response = _context3.sent;
              if (response.code === 200) {
                this.imagePrefix = response.data;
              } else {
                console.error('获取图片前缀失败：', response.message);
              }
              _context3.next = 3;
              break;
            case 2:
              _context3.prev = 2;
              _t3 = _context3["catch"](0);
              console.error('获取图片前缀错误：', _t3);
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function getImagePrefix() {
        return _getImagePrefix2.apply(this, arguments);
      }
      return getImagePrefix;
    }(),
    // 通过ID获取详情
    fetchDetailById: function () {
      var _fetchDetailById = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(id) {
        var res, data, _t4;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 1;
              return (0, _popupConfig.getPopupInfo)(id);
            case 1:
              res = _context4.sent;
              data = res && (res.data || res.xyPopUp || res); // 兼容不同返回包装
              if (!data) {
                _context4.next = 2;
                break;
              }
              _context4.next = 2;
              return this.initFormData(data);
            case 2:
              _context4.next = 4;
              break;
            case 3:
              _context4.prev = 3;
              _t4 = _context4["catch"](0);
              console.error('获取详情失败:', _t4);
              this.$message.error('获取详情失败');
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[0, 3]]);
      }));
      function fetchDetailById(_x) {
        return _fetchDetailById.apply(this, arguments);
      }
      return fetchDetailById;
    }(),
    // 初始化表单数据
    initFormData: function () {
      var _initFormData = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(data) {
        var selectedStores;
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (data) {
                _context5.next = 1;
                break;
              }
              return _context5.abrupt("return");
            case 1:
              // 先处理门店选择数据
              selectedStores = [];
              if (!data.shopIds) {
                _context5.next = 3;
                break;
              }
              selectedStores = this.mapShopIdsToSelectedStores(data.shopIds);
              // 如果返回的是Promise，等待其解析
              if (!(selectedStores instanceof Promise)) {
                _context5.next = 3;
                break;
              }
              _context5.next = 2;
              return selectedStores;
            case 2:
              selectedStores = _context5.sent;
            case 3:
              // 映射列表数据到表单数据
              this.formData = {
                title: data.title || '',
                recommendType: Number(data.recommendType) || 1,
                sendScene: data.sendScene ? data.sendScene.split(',').map(function (v) {
                  return Number(v);
                }) : [],
                isVip: Number(data.isVip) || 1,
                vipGrade: data.vipGrade ? data.vipGrade.split(',').map(function (v) {
                  return Number(v);
                }) : [],
                isAddQy: Number(data.isAddQy) || 1,
                isSaleOrder: Number(data.isSaleOrder) || 1,
                isNewPeopleCoupon: Number(data.isNewPeopleCoupon) || 1,
                userType: Number(data.userType) || 1,
                showImage: data.showImage,
                dateRange: this.formatTimestampToRange(data.showStartTime, data.showEndTime),
                recommendContent: data.recommendContent || '',
                recommendContentId: data.recommendContentId != null ? String(data.recommendContentId) : null,
                recommendContentParam: data.recommendContentParam || null,
                recommendPriority: Number(data.recommendPriority) || 0,
                showPlatform: data.showPlatform ? data.showPlatform.split(',').map(function (v) {
                  return Number(v);
                }) : [1],
                isEnable: data.isEnable !== undefined ? data.isEnable : true,
                isShow: data.isShow !== undefined ? data.isShow : true,
                remark: '',
                selectedStores: selectedStores,
                storeJoinType: Number(data.storeJoinType) || 1,
                vipGradeRadio: Number(data.vipGradeRadio) || null,
                // 修复：确保转换为数字类型
                // 分组类型相关字段
                cdpGrpType: Number(data.cdpGrpType) || 0,
                cdpGrpId: data.cdpGrpId,
                recommendContentSub: data.recommendContentSub || ''
              };
              // 如果有图片，初始化文件列表
              if (this.formData.showImage) {
                this.fileList = [{
                  name: '图片',
                  url: this.formData.showImage,
                  uid: Date.now()
                }];
              }
              if (this.formData.recommendType == 3) {
                this.pageList = this.allPage.filter(function (item) {
                  return item.appid === 'GAGAX' || item.appid === 'DELI';
                });
              } else if (this.formData.recommendType == 6) {
                this.pageList = this.allPage.filter(function (item) {
                  return item.appid === 'GAGAS';
                });
              }
              // 初始化选中的门店 - 确保门店数据已加载后再设置选中状态
              this.setCheckedKeysAfterShopDataLoaded();
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function initFormData(_x2) {
        return _initFormData.apply(this, arguments);
      }
      return initFormData;
    }(),
    // 将时间戳转换为日期范围数组
    formatTimestampToRange: function formatTimestampToRange(startTime, endTime) {
      if (!startTime || !endTime) return [];

      // 将时间戳转换为Date对象
      var startDate = new Date(startTime);
      var endDate = new Date(endTime);
      return [startDate, endDate];
    },
    // 以上映射统一使用数值，去除字符串中间映射
    // 将门店ID映射到选中的门店列表
    mapShopIdsToSelectedStores: function mapShopIdsToSelectedStores(shopIds) {
      var _this2 = this;
      if (!shopIds) return [];
      // 确保在门店数据加载完成后再执行映射
      if (!this.storeTreeData || this.storeTreeData.length === 0) {
        // 如果门店数据未加载完成，返回Promise以便后续处理
        return new Promise(function (resolve) {
          var unwatch = _this2.$watch('storeTreeData', function (newVal) {
            if (newVal && newVal.length > 0) {
              _this2.$nextTick(function () {
                var ids = shopIds.split(',').map(function (id) {
                  return parseInt(id);
                });
                var selectedStores = [];
                var _findStores = function findStores(nodes) {
                  nodes.forEach(function (node) {
                    if (node.children && node.children.length > 0) {
                      _findStores(node.children);
                    } else if (ids.includes(node.id)) {
                      selectedStores.push({
                        id: node.id,
                        name: node.label
                      });
                    }
                  });
                };
                _findStores(_this2.storeTreeData);
                unwatch(); // 取消监听
                resolve(selectedStores);
              });
            }
          });
        });
      } else {
        // 门店数据已加载，直接执行映射
        var ids = shopIds.split(',').map(function (id) {
          return parseInt(id);
        });
        var selectedStores = [];
        var _findStores2 = function findStores(nodes) {
          nodes.forEach(function (node) {
            if (node.children && node.children.length > 0) {
              _findStores2(node.children);
            } else if (ids.includes(node.id)) {
              selectedStores.push({
                id: node.id,
                name: node.label
              });
            }
          });
        };
        _findStores2(this.storeTreeData);
        return selectedStores;
      }
    },
    // 保留数值型推荐类型
    mapRecommendTypeToDbValue: function mapRecommendTypeToDbValue(recommendType) {
      return Number(recommendType) || 1;
    },
    // 在门店数据加载完成后设置选中状态
    setCheckedKeysAfterShopDataLoaded: function setCheckedKeysAfterShopDataLoaded() {
      var _this3 = this;
      return new Promise(function (resolve) {
        // 如果门店数据已经加载完成，直接设置选中状态
        if (_this3.storeTreeData && _this3.storeTreeData.length > 0) {
          _this3.setCheckedKeys();
          resolve();
        } else {
          // 如果门店数据还未加载完成，等待数据加载完成后再设置
          var unwatch = _this3.$watch('storeTreeData', function (newVal) {
            if (newVal && newVal.length > 0) {
              _this3.$nextTick(function () {
                _this3.setCheckedKeys();
                unwatch(); // 取消监听
                resolve();
              });
            }
          });
        }
      });
    },
    // 设置选中的门店keys
    setCheckedKeys: function setCheckedKeys() {
      var _this4 = this;
      if (this.formData.selectedStores && this.formData.selectedStores.length > 0) {
        // 检查selectedStores是否为Promise（异步处理的结果）
        if (this.formData.selectedStores instanceof Promise) {
          this.formData.selectedStores.then(function (resolvedStores) {
            _this4.formData.selectedStores = resolvedStores;
            var checkedKeys = resolvedStores.map(function (store) {
              return 's' + store.id;
            });
            _this4.checkedKeys = checkedKeys;
            if (_this4.$refs.storeTree) {
              _this4.$refs.storeTree.setCheckedKeys(checkedKeys);
            }
          });
        } else {
          var checkedKeys = this.formData.selectedStores.map(function (store) {
            return 's' + store.id;
          });
          this.checkedKeys = checkedKeys;
          if (this.$refs.storeTree) {
            this.$refs.storeTree.setCheckedKeys(checkedKeys);
          }
        }
      } else {
        // 没有选中的门店，清空选中状态
        this.checkedKeys = [];
        if (this.$refs.storeTree) {
          this.$refs.storeTree.setCheckedKeys([]);
        }
      }
    },
    // 格式化日期时间为Java后端可识别的格式
    formatDateTime: function formatDateTime(date) {
      if (!date) return null;

      // 统一返回时间戳
      if (date instanceof Date) {
        return date.getTime();
      }

      // 如果是字符串，先转换为Date再取时间戳
      if (typeof date === 'string') {
        return new Date(date).getTime();
      }
      return date;
    },
    // 处理图片选择
    handleImageChange: function handleImageChange(file, fileList) {
      var _this5 = this;
      if (file.status === 'ready') {
        // 本地预览
        var reader = new FileReader();
        reader.onload = function (e) {
          file.url = e.target.result;
          _this5.fileList = [_objectSpread({}, file)];
        };
        reader.readAsDataURL(file.raw);

        // 开始上传
        (0, _popupConfig.uploadPopupImage)(file.raw).then(function (res) {
          var url = res && res.data || res;
          if (!url) {
            _this5.$message.error('上传失败');
            return;
          }
          // 设置为返回的URL
          _this5.formData.showImage = url;
          // 更新fileList中的展示URL
          _this5.fileList = [{
            name: file.name,
            url: url,
            uid: file.uid
          }];
          _this5.$message.success('图片上传成功');
        }).catch(function (err) {
          console.error('图片上传失败:', err);
          _this5.$message.error('图片上传失败');
          _this5.fileList = [];
          _this5.formData.showImage = null;
        });
      }
    },
    // 处理图片移除
    handleImageRemove: function handleImageRemove(file) {
      this.fileList = [];
      this.formData.showImage = null;
    },
    // 处理图片预览
    handleImagePreview: function handleImagePreview(file) {
      this.previewImageUrl = file.url;
      this.previewVisible = true;
    },
    // 处理超出限制
    handleExceed: function handleExceed(files, fileList) {
      this.$message.warning('只能上传一张图片!');
    },
    // 上传前验证
    beforeImageUpload: function beforeImageUpload(file) {
      var isImage = file.type.indexOf('image/') === 0;
      if (!isImage) {
        this.$message.error('只能上传图片文件!');
        return false;
      }
      if (file.size / 1024 / 1024 > 2) {
        this.$message.error('图片大小不能超过 2MB!');
        return false;
      }
      return false; // 阻止自动上传
    },
    // 处理门店选择变化
    handleStoreCheck: function handleStoreCheck(data, checked) {
      // 获取当前选中的门店
      var checkedNodes = this.$refs.storeTree.getCheckedNodes();
      // 只获取门店节点（排除区域节点）
      var selectedStores = checkedNodes.filter(function (node) {
        return !node.isRegion;
      });
      this.formData.selectedStores = selectedStores.map(function (store) {
        return {
          id: store.id,
          name: store.label
        };
      });
      console.log('已选择门店:', this.formData.selectedStores);
    },
    // 选择全部门店
    selectAllStores: function selectAllStores() {
      // 获取所有门店节点（叶子且非区域）的nodeKey
      var _getAllLeafKeys = function getAllLeafKeys(nodes) {
        var keys = [];
        nodes.forEach(function (node) {
          if (node.isRegion) {
            keys = keys.concat(_getAllLeafKeys(node.children || []));
          } else {
            keys.push(node.nodeKey);
          }
        });
        return keys;
      };
      var allLeafKeys = _getAllLeafKeys(this.storeTreeData);
      var currentCheckedKeys = this.$refs.storeTree.getCheckedKeys();

      // 检查当前是否已全选（包含叶子节点和部分父节点）
      var isAllSelected = allLeafKeys.every(function (key) {
        return currentCheckedKeys.includes(key);
      });
      if (isAllSelected) {
        // 如果已经全选，则取消全选
        this.$refs.storeTree.setCheckedKeys([]);
        this.formData.selectedStores = [];
        this.$message.info('已取消全选');
      } else {
        // 否则全选
        this.$refs.storeTree.setCheckedKeys(allLeafKeys);
        // 更新选中的门店列表
        var allStores = [];
        var _collectLeafNodes = function collectLeafNodes(nodes) {
          nodes.forEach(function (node) {
            if (node.isRegion) {
              _collectLeafNodes(node.children || []);
            } else {
              allStores.push({
                id: node.id,
                name: node.label
              });
            }
          });
        };
        _collectLeafNodes(this.storeTreeData);
        this.formData.selectedStores = allStores;
        this.$message.success("\u5DF2\u9009\u4E2D ".concat(allStores.length, " \u4E2A\u95E8\u5E97"));
      }
    },
    // 导入Excel门店ID
    handleExcelImport: function handleExcelImport(file) {
      var _this6 = this;
      var reader = new FileReader();
      reader.onload = function (e) {
        try {
          var data = new Uint8Array(e.target.result);
          var workbook = _xlsx.default.read(data, {
            type: 'array'
          });
          var sheet = workbook.Sheets[workbook.SheetNames[0]];
          var rows = _xlsx.default.utils.sheet_to_json(sheet, {
            header: 1
          });

          // 获取所有门店节点的ID（即所有门店ID）
          var allLeafIds = [];
          var _collectLeafIds = function collectLeafIds(nodes) {
            nodes.forEach(function (node) {
              if (node.isRegion) {
                _collectLeafIds(node.children || []);
              } else {
                allLeafIds.push(node.id);
              }
            });
          };
          _collectLeafIds(_this6.storeTreeData);

          // 从Excel读取门店ID（第一列）
          var importedIds = [];
          rows.forEach(function (row) {
            if (row && row[0] !== undefined && row[0] !== null) {
              var id = String(row[0]).trim();
              if (id && !isNaN(Number(id))) {
                importedIds.push(Number(id));
              }
            }
          });

          // 匹配门店
          var matched = importedIds.filter(function (id) {
            return allLeafIds.includes(id);
          });

          // 合并到当前已选中的keys（门店storeId需转换为nodeKey）
          var currentChecked = _this6.$refs.storeTree.getCheckedKeys();
          var merged = (0, _toConsumableArray2.default)(new Set([].concat((0, _toConsumableArray2.default)(currentChecked), (0, _toConsumableArray2.default)(matched.map(function (id) {
            return 's' + id;
          })))));
          _this6.$refs.storeTree.setCheckedKeys(merged);

          // 更新formData.selectedStores
          var allStores = [];
          var _collectMatchedStores = function collectMatchedStores(nodes) {
            nodes.forEach(function (node) {
              if (node.isRegion) {
                _collectMatchedStores(node.children || []);
              } else if (merged.includes(node.nodeKey)) {
                allStores.push({
                  id: node.id,
                  name: node.label
                });
              }
            });
          };
          _collectMatchedStores(_this6.storeTreeData);
          _this6.formData.selectedStores = allStores;
          var unmatched = importedIds.filter(function (id) {
            return !allLeafIds.includes(id);
          });
          var msg = "\u5BFC\u5165\u6210\u529F\uFF1A\u5171".concat(importedIds.length, "\u4E2A\u95E8\u5E97ID\uFF0C\u5339\u914D").concat(matched.length, "\u4E2A");
          if (unmatched.length > 0) {
            msg += "\uFF0C".concat(unmatched.length, "\u4E2A\u672A\u5339\u914D");
          }
          _this6.$message.success(msg);
        } catch (err) {
          _this6.$message.error('Excel解析失败，请检查文件格式');
        }
      };
      reader.readAsArrayBuffer(file.raw);
    },
    // 过滤节点
    filterNode: function filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    // 移除单个门店
    removeStore: function removeStore(store) {
      // 从选中列表中移除
      this.formData.selectedStores = this.formData.selectedStores.filter(function (s) {
        return s.id !== store.id;
      });
      // 同时取消树中的选中状态
      var checkedKeys = this.$refs.storeTree.getCheckedKeys();
      var newCheckedKeys = checkedKeys.filter(function (key) {
        return key !== 's' + store.id;
      });
      this.$refs.storeTree.setCheckedKeys(newCheckedKeys);
    },
    // 提交表单
    handleSubmit: function () {
      var _handleSubmit = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var _this7 = this;
        var valid, submitData;
        return regeneratorRuntime.wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 1;
              return this.$refs.menuPageForm.validate();
            case 1:
              valid = _context6.sent;
              if (!valid) {
                _context6.next = 3;
                break;
              }
              _context6.next = 2;
              return this.setCheckedKeysAfterShopDataLoaded();
            case 2:
              // 社区模式：清理"其他"模式遗留的appid（recommendContentId 必须是选中的页面ID）
              if (this.formData.recommendType == 6 && this.formData.recommendContentSub == 'GAGAS') {
                if (!this.pageList.some(function (p) {
                  return p.id === _this7.formData.recommendContentId;
                })) {
                  this.formData.recommendContentId = '';
                }
                this.formData.recommendContent = '';
              }

              // 构造要提交的数据
              submitData = {
                id: this.isEdit && this.editId ? this.editId : null,
                title: this.formData.title,
                recommendType: this.formData.recommendType,
                recommendContent: this.formData.recommendContent,
                recommendContentId: this.formData.recommendContentId,
                recommendContentParam: this.formData.recommendContentParam,
                recommendPriority: this.formData.recommendPriority || 0,
                popType: this.popupType,
                // 动态设置弹窗类型
                sendScene: (this.formData.sendScene || []).join(','),
                showStartTime: this.formatDateTime(this.formData.dateRange[0]),
                showEndTime: this.formatDateTime(this.formData.dateRange[1]),
                showPlatform: (this.formData.showPlatform || []).join(','),
                showImage: this.formData.showImage ? this.formData.showImage.name || this.formData.showImage : '',
                isEnable: this.formData.isEnable,
                isShow: this.formData.isShow,
                isVip: this.formData.isVip,
                isAddQy: this.formData.isAddQy,
                isSaleOrder: this.formData.isSaleOrder,
                isNewPeopleCoupon: this.formData.isNewPeopleCoupon,
                vipGrade: (this.formData.vipGrade || []).join(','),
                vipGradeRadio: this.formData.vipGradeRadio,
                userType: this.formData.userType,
                shopIds: (this.formData.selectedStores || []).map(function (s) {
                  return s.id;
                }).join(','),
                storeJoinType: this.formData.storeJoinType,
                cdpGrpType: this.formData.cdpGrpType,
                cdpGrpId: this.formData.cdpGrpId,
                recommendContentSub: this.formData.recommendContentSub
              }; // 调用API保存数据
              (0, _popupConfig.saveOrUpdatePopupConfig)(submitData).then(function (response) {
                var action = _this7.isEdit ? '编辑' : '添加';
                _this7.$message.success("".concat(action, "\u6210\u529F"));
                console.log('保存成功:', response);
                // 保存成功后关闭标签页
                _this7.$emit('saved');
                _this7.$emit('cancel');
              }).catch(function (error) {
                console.error('保存失败:', error);
                _this7.$message.error('保存失败');
              });
              _context6.next = 4;
              break;
            case 3:
              this.$message.error('请完善表单信息');
              return _context6.abrupt("return", false);
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function handleSubmit() {
        return _handleSubmit.apply(this, arguments);
      }
      return handleSubmit;
    }(),
    // 获取页面列表
    getPageList: function () {
      var _getPageList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var response, _t5;
        return regeneratorRuntime.wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              _context7.next = 1;
              return (0, _popupConfig.queryPageList)();
            case 1:
              response = _context7.sent;
              if (response.code === 200 && response.data) {
                // 将返回的页面数据转换为下拉选项格式
                this.allPage = response.data.map(function (item) {
                  return {
                    value: item.pageUrl,
                    label: item.pageName,
                    appid: item.appid,
                    id: String(item.id)
                  };
                });
                this.pageList = this.allPage;
                // 更新contentTypeOptions以使用从接口获取的页面数据
                this.contentTypeOptions = this.pageList;
                // console.log('获取页面列表成功：', this.pageList)
                if (this.formData.recommendType == 3) {
                  this.pageList = this.allPage.filter(function (item) {
                    return item.appid === 'GAGAX' || item.appid === 'DELI';
                  });
                } else if (this.formData.recommendType == 6) {
                  this.pageList = this.allPage.filter(function (item) {
                    return item.appid === 'GAGAS';
                  });
                }
              } else {
                console.error('获取页面列表失败：', response.message);
              }
              _context7.next = 3;
              break;
            case 2:
              _context7.prev = 2;
              _t5 = _context7["catch"](0);
              console.error('获取页面列表错误：', _t5);
              this.$message.error('获取页面列表失败');
            case 3:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this, [[0, 2]]);
      }));
      function getPageList() {
        return _getPageList.apply(this, arguments);
      }
      return getPageList;
    }(),
    // 处理CDP分组类型变化
    handleCdpGrpTypeChange: function handleCdpGrpTypeChange(value) {
      // 清空之前选择的分组
      this.formData.cdpGrpId = null;
      this.cdpGroupOptions = [];

      // 如果选择了分组类型，则查询对应的分组列表
      if (value !== 0) {
        this.queryCdpGroupList('');
      }
    },
    // 查询CDP分组或消费行为信息
    queryCdpGroupList: function () {
      var _queryCdpGroupList2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee8(query) {
        var response, _t6;
        return regeneratorRuntime.wrap(function (_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (!(this.formData.cdpGrpType === 0)) {
                _context8.next = 1;
                break;
              }
              this.cdpGroupOptions = [];
              return _context8.abrupt("return");
            case 1:
              _context8.prev = 1;
              this.cdpGroupLoading = true;
              _context8.next = 2;
              return (0, _popupConfig.queryCdpGroupList)({
                type: this.formData.cdpGrpType,
                name: query
              });
            case 2:
              response = _context8.sent;
              if (response.code === 200) {
                this.cdpGroupOptions = response.data.map(function (item) {
                  return {
                    value: item.id,
                    label: item.name
                  };
                });
              } else {
                this.$message.error('查询分组列表失败: ' + (response.message || '未知错误'));
              }
              _context8.next = 4;
              break;
            case 3:
              _context8.prev = 3;
              _t6 = _context8["catch"](1);
              console.error('查询分组列表错误:', _t6);
              this.$message.error('查询分组列表失败: ' + (_t6.message || '网络错误'));
            case 4:
              _context8.prev = 4;
              this.cdpGroupLoading = false;
              return _context8.finish(4);
            case 5:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this, [[1, 3, 4, 5]]);
      }));
      function queryCdpGroupList(_x3) {
        return _queryCdpGroupList2.apply(this, arguments);
      }
      return queryCdpGroupList;
    }(),
    // 取消操作
    handleCancel: function handleCancel() {
      this.$emit('cancel');
    }
  }
};